(() => {
  'use strict';
  function conciseSpec(label, source) {
    const text = source.replace(/™|®/g, '').replace(/\s+/g, ' ').trim();
    if (label === 'GPU') {
      const model = text.match(/(?:RTX|GTX|RX)\s*\d{3,4}\s*(?:Ti|SUPER|XTX|XT)?/i) || text.match(/(?:ARC\s*[AB]\d{3}|Radeon\s*(?:Vega\s*\d+|\d{3}M))/i);
      const memory = text.match(/\b(\d+)\s*GB\b/i);
      if (model) return model[0].trim() + (memory ? ' · ' + memory[1] + ' GB' : '');
    }
    if (label === 'CPU') {
      const model = text.match(/Ryzen\s*[3579]\s*\d{4}[A-Z0-9]*/i) || text.match(/Core\s*(?:Ultra\s*[3579]\s*\d+[A-Z]*|i[3579][-\s]*\d+[A-Z]*)/i);
      if (model) return model[0];
    }
    if (label === 'RAM') {
      const kit = text.match(/\b(\d+)\s*[x×]\s*(\d+)\s*GB\b/i);
      const capacity = text.match(/\b(\d+)\s*GB\b/i);
      const type = text.match(/DDR[345]/i);
      if ((kit || capacity) && type) return (kit ? Number(kit[1]) * Number(kit[2]) : capacity[1]) + ' GB ' + type[0];
    }
    if (label === 'SSD') {
      const capacity = text.match(/\b\d+(?:[.,]\d+)?\s*(?:TB|GB)\b/i);
      if (capacity) return capacity[0] + (/NVMe/i.test(text) ? ' NVMe' : ' SSD');
    }
    return text;
  }
  function polish(scope) {
    const choices = [ ['PC PRONTO','SCOPRI'], ['CREARLO IO','CONFIGURA'], ['PIÙ FPS','MIGLIORA'] ];
    scope.querySelectorAll('.journey-card').forEach((card, index) => {
      if (!choices[index]) return;
      const cta = card.querySelector('.journey-cta');
      if (cta && !cta.dataset.mgConciseCta) {
        const original = Array.from(cta.childNodes).find(node => node.nodeType === 3);
        if (original) {
          const desktop = document.createElement('span');
          desktop.className = 'mg-journey-desktop-cta';
          desktop.textContent = original.textContent;
          const mobile = document.createElement('span');
          mobile.className = 'mg-journey-mobile-cta';
          mobile.textContent = choices[index][1];
          original.replaceWith(desktop, mobile);
        }
        cta.dataset.mgConciseCta = 'true';
      }
      card.setAttribute('aria-label', choices[index][0] + ': ' + (index === 0 ? 'scopri i PC Gaming' : index === 1 ? 'apri il configuratore' : 'scopri Minimal Booster'));
    });
    scope.querySelectorAll('.community-build-specs>span').forEach(row => {
      const value = row.querySelector('b');
      const label = row.querySelector('small')?.textContent.trim();
      if (!value || !label) return;
      if (value.dataset.mgCompactSpec === value.textContent) return;
      const original = value.textContent.trim();
      const compact = conciseSpec(label, original);
      value.title = original;
      value.textContent = compact;
      value.dataset.mgCompactSpec = compact;
    });
  }
  function init() {
    document.querySelectorAll('[data-mg-rex-pdp]').forEach(product => {
      const deduplicate = () => product.querySelectorAll('[data-mg-spec-index]').forEach(card => {
        const label = card.querySelector('[data-mg-spec-label]');
        const detail = card.querySelector('[data-mg-spec-detail]');
        const normalize = node => (node?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (detail) detail.toggleAttribute('data-mg-duplicate-spec', !!normalize(label) && normalize(label) === normalize(detail));
      });
      deduplicate();
      product.addEventListener('mg:product-profile', () => requestAnimationFrame(deduplicate));
    });
    const scope = document.getElementById('root');
    if (!scope) return;
    polish(scope);
    let queued = false;
    const observer = new MutationObserver(records => {
      if (queued || !records.some(record => record.addedNodes.length)) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; polish(scope); });
    });
    observer.observe(scope, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
